import { gsap } from 'gsap';

export class Roulette {
    private items: string[];
    private currentIndex: number = 0;
    private isRunning: boolean = false;
    private interval: ReturnType<typeof setInterval> | null = null;

    private stopSound: HTMLAudioElement;
    private successSound: HTMLAudioElement;

    constructor(items: string[]) {
        this.items = items;
        this.stopSound = new Audio(new URL('../assets/sounds/stop.mp3', import.meta.url).href);
        this.successSound = new Audio(new URL('../assets/sounds/sucess.mp3', import.meta.url).href);
        this.setupEventListeners();
    }

    private setupEventListeners() {
        document.addEventListener('keydown', (e) => {
            if (e.code === 'Space') {
                if (this.isRunning) {
                    this.stop();
                } else {
                    this.start();
                }
            }
        });
    }

    public start() {
        this.isRunning = true;
        
        const selectedItem = document.getElementById('selected-item')!;
        gsap.killTweensOf(selectedItem);
        selectedItem.style.display = 'none';
        selectedItem.style.transform = 'translate(-50%, -50%)';
        
        const bgUrl = new URL('../assets/images/background/bg.png', import.meta.url).href;
        const background = document.getElementById('background')!;
        background.innerHTML = '';
        background.style.backgroundImage = `url(${bgUrl})`;
        
        document.getElementById('roulette-items')!.style.display = 'block';
        
        this.interval = setInterval(() => {
            this.updateItem();
        }, 100);
    }

    private updateItem() {
        const items = document.querySelectorAll('.roulette-item');
        items[this.currentIndex].classList.remove('active');
        this.currentIndex = (this.currentIndex + 1) % this.items.length;
        items[this.currentIndex].classList.add('active');
    }

    private stop() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.isRunning = false;
        this.stopSound.play();
        setTimeout(() => {
            this.showSelectedItem();
        }, 500);
    }

    private showSelectedItem() {
        const selectedItem = document.getElementById('selected-item')!;
        selectedItem.style.display = 'block';
        selectedItem.style.backgroundImage = `url(${this.items[this.currentIndex]})`;
        selectedItem.style.backgroundSize = 'contain';
        selectedItem.style.backgroundRepeat = 'no-repeat';
        selectedItem.style.backgroundPosition = 'center';

        document.getElementById('roulette-items')!.style.display = 'none';

        const background = document.getElementById('background')!;
        background.innerHTML = '';

        const videoElement = document.createElement('video');
        videoElement.src = new URL('../assets/images/background/bg2.mp4', import.meta.url).href;
        videoElement.playsInline = true;
        videoElement.autoplay = true;
        videoElement.loop = true;
        videoElement.muted = true;
        
        console.log('Video source:', videoElement.src);
        
        videoElement.addEventListener('loadedmetadata', () => {
            console.log('Video metadata loaded');
            videoElement.play().catch(error => {
                console.error('Video playback failed:', error);
            });
        });

        videoElement.addEventListener('error', (e) => {
            console.error('Video error:', videoElement.error);
            const fallbackBgUrl = new URL('../assets/images/background/bg2.mp4', import.meta.url).href;
            background.style.backgroundImage = `url(${fallbackBgUrl})`;
        });

        Object.assign(videoElement.style, {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        });

        background.appendChild(videoElement);

        gsap.from(selectedItem, {
            scale: 0.5,
            duration: 0.5,
            ease: "back.out(1.7)",
            onComplete: () => {
                this.successSound.play();
            }
        });

        gsap.to(selectedItem, {
            y: "+=20",
            duration: 1,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut"
        });
    }
} 